import React, { FC } from 'react';
import { useSelector } from 'react-redux';
import { ReduxStore } from '@trip-ux/redux-store';
import { labelsSelector } from '../utils';
import { get, isEmpty } from 'lodash';

export interface RequiredFieldsPageHintProps {
  /**
   * Optional TMS label path (e.g. 'page.hintDestinationPricing') that overrides
   * the default 'page.hint' key. Falls back to 'page.hint' if the override is
   * missing/empty.
   */
  hintKey?: string;
}

export const RequiredFieldsPageHint: FC<RequiredFieldsPageHintProps> = ({ hintKey }) => {
  const { labels } = useSelector((store: ReduxStore) => ({
    labels: labelsSelector(store)
  }));
  const overrideHint = hintKey ? get(labels, hintKey) : undefined;
  const hint = !isEmpty(overrideHint) ? overrideHint : get(labels, 'page.hint');

  if (isEmpty(hint)) {
    return null;
  }

  return (
    <label data-testid="page-hint" className="page-hint">
      {hint}
    </label>
  );
};

RequiredFieldsPageHint.displayName = 'RequiredFieldsPageHint';
export default RequiredFieldsPageHint;
